/*
 * Copyright (c) 2023 CalAmp Corp.  All Rights Reserved
 */
import React, {memo} from 'react';
import {translate} from '@ion/core/src/locale/locale';
import {IonSnackbar} from '@ion/dls/src/notifications/IonSnackbar';

/**
 * How long a snackbar message should wait before automatically dismissing.
 * Currently set to 5 seconds.
 */
const SNACK_AUTO_HIDE_DURATION = 5 * 1000;

export interface SnackbarMessageProps {
  onDismiss: () => void;
  message: string;
  show: boolean;
  duration?: number
}

/**
 * Temporarily displays a snackbar with a message.
 *
 * ```typescript
 *
 * import SnackbarMessage from '@ion/dls/src/components/snackbars';
 *
 * <SnackbarMessage show={show}
 *   message={translate('common.complete')}
 *   onDismiss={onDismiss} />
 *
 * ```
 */
export const SnackbarMessage = ({
  show,
  message,
  onDismiss,
  duration = SNACK_AUTO_HIDE_DURATION
}: SnackbarMessageProps) => (
  <IonSnackbar show={show}
    autoHideDuration={duration}
    message={message}
    actionLabel={translate('common:dismiss')}
    onAction={onDismiss}
    onClose={onDismiss} />
);

export default memo(SnackbarMessage);
